import React, { type FC, type JSX, useEffect, useRef } from 'react';
import { Switch } from '@lmn/design-system';
import { ToggleContainer } from '@/app/components/search/components/Form/children/Checkbox/Toggle/styled.ts';

type ToggleProps = {
  value: boolean;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
  disabled?: boolean;
};

// Accessible semantics live on the parent Label; the Switch is visual only.
const Toggle: FC<ToggleProps> = ({ value, setValue, disabled }): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Drop the Switch's input from the tab order (no prop forwards to it).
  useEffect(() => {
    const input = containerRef.current?.querySelector('input');
    if (input) {
      input.tabIndex = -1;
    }
  }, []);

  return (
    <ToggleContainer ref={containerRef} aria-hidden="true">
      {/* The Switch has its own internal input; without disabled it stays clickable past the disabled Checkbox input. */}
      <Switch checked={value} onChange={(checked) => setValue(checked)} disabled={disabled} ltr={true} label="" />
    </ToggleContainer>
  );
};

export default Toggle;
